import type registerZh from '../zh/register';

const register: typeof registerZh = {
  password_mismatch: 'The two passwords do not match',
  email_invalid: 'Please enter a valid email address!',
  email_incorrect: 'Please enter a valid email',
  title: '米通 | Admin registration',
  email_placeholder: 'Enter email',
  send_code: 'Send code',
  password_again: 'Enter password again'
};

export default register;
